import React from 'react'

/**
 * Img Wrapper
 * @param {object} props
 * @param {string} props.src
 * @param {string} props.alt
 * @param {string} [props.defaultSrc]
 * @param {string} [props.title]
 * @param {string} [props.className]
 */
const ImgWrapper = (props) => {
  const { src, alt, defaultSrc = '', title, className = '' } = props

  return (
    <img
      src={src || defaultSrc}
      alt={alt || ''}
      title={title || ''}
      className={className}
      onError={
        event => {
          event.target.src = defaultSrc
          event.onerror = null
        }
      }
    />
  )
}

export default ImgWrapper